module.exports = __webpack_public_path__ + "static/media/flag-ay.a6c6d368.webp";